
"use strict";

class PromptDialogController {


    constructor( $scope, $mdDialog) {

    	this.$mdDialog = $mdDialog;

		//Ugly work around OK button!
    	$scope.ok = () => {
    		this.ok();
    	};
    }

	/*
     * managed OK event from confirm dialog
     */
    ok () {
        this.$mdDialog.hide();
	}
}


/*
 * Inject dependicies
 */
PromptDialogController.$inject = ['$scope', '$mdDialog'];

/*
 * Browsify connection: execute controller
 */
module.exports = PromptDialogController;
